import React, { FunctionComponent } from "react";
import CartTotalLine from "@Components/molecules/cart/CartCheckoutTotal/CartTotalLine";
import CartPromoCode from "@Components/molecules/cart/CartPromoCode";
import useCartContext from "@Hooks/useCartContext";
import { Price } from "@Types/api/price";
import "./style.scss";

interface Props extends ContainerProps {
  disabled?: boolean;
  onRemovePromoCode: () => void;
  promoCode?: string;
  promoTotal: Price;
}

interface ContainerProps {
  onUpdatePromoCode: (promoCode: string | undefined) => void;
  promoCodeErrorMessage: string | undefined;
}

export const CartDiscountContent: FunctionComponent<Props> = ({
  disabled = false,
  onRemovePromoCode,
  onUpdatePromoCode,
  promoCode,
  promoCodeErrorMessage,
  promoTotal,
}) => {
  return (
    <div className="CartDiscountContent">
      {promoCode ? (
        <CartTotalLine
          disabled={disabled}
          label={promoCode}
          onDismiss={onRemovePromoCode}
          total={promoTotal}
        />
      ) : (
        <CartPromoCode
          disabled={disabled}
          errorMessage={promoCodeErrorMessage}
          onUpdatePromoCode={onUpdatePromoCode}
        />
      )}
    </div>
  );
};

const CartDiscountContentContainer: FunctionComponent<ContainerProps> = ({
  onUpdatePromoCode,
  promoCodeErrorMessage,
}) => {
  const { cart } = useCartContext();

  const handleRemovePromoCode = () => {
    onUpdatePromoCode(undefined);
  };

  return (
    <CartDiscountContent
      onUpdatePromoCode={onUpdatePromoCode}
      onRemovePromoCode={handleRemovePromoCode}
      promoCode={cart.promoCode}
      promoCodeErrorMessage={promoCodeErrorMessage}
      promoTotal={cart.promoTotal}
    />
  );
};

export default CartDiscountContentContainer;
